export default __webpack_public_path__ + "static/media/trustSuccessDark.d1ff53fd.svg";